import { APP_BACKEND_ESG } from "@/constants";
import axios from "axios";

const base_url = APP_BACKEND_ESG;

export const upload = async (file, type) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("type", type);

  const result = await axios.post(`${base_url}/attachment/upload`, formData, {
    headers: {
      accept: "*/*",
    },
  });
  return result.data;
};

export const getUrlFile = async (filename) => {
  const bodyJson = { filepath: filename };
  const response = await axios.post(
    `${base_url}/attachment/download`,
    bodyJson,
    {
      headers: {
        Accept: "*/*",
      },
    }
  );
  return response.data;
};
